import { render, staticRenderFns } from "./ShowFavorites.vue?vue&type=template&id=392a80c2&scoped=true"
import script from "./ShowFavorites.vue?vue&type=script&lang=js"
export * from "./ShowFavorites.vue?vue&type=script&lang=js"
import style0 from "./ShowFavorites.vue?vue&type=style&index=0&id=392a80c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392a80c2",
  null
  
)

export default component.exports